/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown>, list: NonNullable<unknown>, saved: NonNullable<unknown> }} Receipt_Discount_NoteInputs */



/**
* | output |
* | --- |
* | "Prices include the {percent}% partner discount · list price {list} · saved {saved}" |
*
* @param {Receipt_Discount_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_discount_note = /** @type {((inputs: Receipt_Discount_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Discount_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Preise inkl. ${i?.percent} % Partnerrabatt · Listenpreis ${i?.list} · gespart ${i?.saved}`)
	return /** @type {LocalizedString} */ (`Prices include the ${i?.percent}% partner discount · list price ${i?.list} · saved ${i?.saved}`)
});